import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import '../../styles/WeltewMobilya.css';
import { FaWhatsapp, FaTimes } from "react-icons/fa";

const WeltewMobilya = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isDetailOpen, setIsDetailOpen] = useState(false);

  useEffect(() => {
    // URL'deki hash'i kontrol et ve ilgili bölüme scroll et
    if (window.location.hash) {
      const element = document.getElementById(window.location.hash.substring(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }, []);

  const handleProductClick = (productId) => {
    // Ürün bilgisinin var olup olmadığını kontrol et
    if (products[productId]) {
      setSelectedProduct(productId);
      setIsDetailOpen(true);
      document.body.style.overflow = 'hidden'; // Scroll'u engelle
    } else {
      console.error('Ürün bulunamadı:', productId);
    }
  };

  const closeDetail = () => {
    setIsDetailOpen(false);
    setSelectedProduct(null);
    document.body.style.overflow = 'auto'; // Scroll'u geri aç
  };

    // Ürün bilgileri
  const products = {
    'traverta-yatak-odasi': {
      name: 'Traverta Yatak Odası',
      image: '../files/traverta-yatak-odasi.webp',
      description: 'Traverta desenli yatak odası takımı ile odanıza şıklık katın.',
      features: [
        'Traverten Dokusu & Reflekte Cam',
        'Bronz Metal Detaylar',
        'Metal Aydınlatma Aplikleri',
        'LED Aydınlatmalı Askılıklar',
        'Frenli Ray Sistemi',
        'E1 Uygunluk Belgeli',
        'Deprem Aparatlı Güvenlik',
        'CE Sertifikalı Elektrikli Ürünler'
      ],
      dimensions: 'G: 235cm, D: 185-205cm, Y: 39cm',
      material: '1. Kalite Melamin Kaplı Yonga Levha',
      warranty: '2 Yıl Garanti',
      price: "117.227,00 ₺'den başlayan fiyatlarla",
      technicalDetails: {
        production: 'Melamin kaplı yonga levha (25, 18, 8 mm) + Traverten PVC kaplı MDF ayak ve kulplar',
        safety: 'E1 formaldehit standardı, RoHS direktifi uyumlu, kurşun içermez',
        features: 'Frenli menteşe, teleskopik raylar, deprem aparatı, LED aydınlatma'
      }
    },
    'bodrum-yatak-odasi': {
      name: 'Bodrum Yatak Odası',
      image: '../files/bodrum-yatak-odasi.webp',
      description: 'İncelikli detaylarıyla yatak odalarında hoş bir atmosfer sunmak için tasarlandı.',
      features: [
        'Bronz Reflekte Cam Detaylar',
        'Doğal Ahşap Dokular',
        'Alüminyum Çerçeveli Kapaklar',
        'Kurutulmuş Kayın Ağacı Ayaklar',
        'MDF İşlemeli Kapaklar',
        'Estetik & Fonksiyonel Tasarım',
        'Uzun Ömürlü Duruş',
        'Dayanıklı Modüller'
      ],
      dimensions: 'G: 318cm, D: 213cm, Y: 125cm',
      material: '1. Kalite Melamin Kaplı Yonga Levha',
      warranty: '2 Yıl Garanti',
      price: "126.661,00 ₺'den başlayan fiyatlarla",
      technicalDetails: {
        production: 'Melamin kaplı yonga levha + MDF işlemeler + Demir profil baza + Kayın ağacı ayaklar',
        materials: 'Bronz reflekte cam, alüminyum çerçeve, MDF kapak işlemeleri',
        features: 'Sağlam yapı, doğal ahşap detaylar, fonksiyonel modüller'
      }
    },
    'salda-yatak-odasi': {
      name: 'Salda Yatak Odası',
      image: '../files/salda-yatak-odasi.webp',
      description: 'Salda gölü esintisinde huzurlu bir yatak odası takımı.',
      features: ['Huzur Verici', 'Doğal Tonlar', 'Minimalist', 'Fonksiyonel', 'Şık Detaylar'],
      dimensions: 'G: 218cm, D: 180cm, Y: 37cm',
      material: 'Masif Ahşap + Mat Vernik',
      warranty: '2 Yıl Garanti',
      price: "110.507,00 ₺'den başlayan fiyatlarla",
    },
    'traverta-yemek-odasi': {
      name: 'Traverta Yemek Odası',
      image: '../files/traverta-yemek-odasi.webp',
      description: 'Yıla damga vuran en özel taş dokulardan ve doğanın benzersiz desenlerinden ilham alan Traverta koleksiyonu.',
      features: [
        'Traverten Dokusu Tasarım',
        'Oval Hatlar & Keskin Çizgiler',
        'Ergonomik Masa & Sandalyeler',
        'Asimetrik Form Konsol',
        'Yavaşlatıcı Amortisörler',
        'E1 Uygunluk Belgeli',
        'CE Sertifikalı Elektrikli',
        'Traverten PVC Kaplı Kulplar'
      ],
      dimensions: 'G: 195cm, D: 95cm, Y: 75cm',
      material: 'Melamin Kaplı Yonga Levha',
      warranty: '2 Yıl Garanti',
      price: "68.225,00 ₺'den başlayan fiyatlarla",
    },
    'bodrum-yemek-odasi': {
      name: 'Bodrum Yemek Odası',
      image: '../files/bodrum-yemek-odasi.webp',
      description: 'Ahşabın huzur veren şıklığı ve bohem zarafeti modern şıklıkla mükemmel uyum içinde.',
      features: [
        'Özgün Sandalye Tasarımları',
        'Modern Aydınlatma Ögeleri',
        'Bank ile Ek Oturum Alanı',
        'İkili Ayna Konsol',
        'Frenli Menteşe Sistemi',
        'Bohem & Modern Uyum',
        'Kurutulmuş Kayın Ağacı',
        'CNC İşlemli Detaylar'
      ],
      dimensions: 'G: 195cm, Y: 76cm, D: 95cm',
      material: 'Melamin Kaplı Yonga Levha',
      warranty: '2 Yıl Garanti',
      price: "65.719,00 ₺'den başlayan fiyatlarla",
      technicalDetails: {
        production: 'Melamin kaplı yonga levha konsol + MDF profil + Boyalı kayın ağacı ayaklar',
        materials: 'Yarım ay işlemli CNC masa + PVC kaplı MDF ayaklar + Sünger kumaş sandalye',
        features: 'Soft işlemli çekmece, metal gerdirme, frenli menteşeler, ergonomik tasarım'
      }
    },
    'cunda-yemek-odasi': {
      name: 'Cunda Yemek Odası',
      image: '../files/cunda-yemek-odasi.jpg',
      description: 'Doğal ahşap dokusunu modern tasarımla buluşturan Cunda yemek odası takımı.',
      features: ['Doğal Ahşap', '6 Kişilik Set', 'Modern Tasarım', 'Mükemmel Kalite'],
      dimensions: 'G: 200cm, Y: 78cm, D: 100cm',
      material: 'Melamin Kaplı Yonga Levha',
      warranty: '2 Yıl Garanti',
      price: "63.777,00 ₺'den başlayan fiyatlarla",
    },
    'traverta-koltuk-takimi': {
      name: 'Traverta Koltuk Takımı',
      image: '../files/traverta-koltuk-takimi.jpg',
      description: 'Yıla damga vuran en özel taş dokulardan ve doğanın benzersiz desenlerinden ilham alan Traverta koleksiyonu.',
      features: [
        'Ekstra Kuş Tüyü Rahatlığı',
        'Yuvarlak Hat Tasarım',
        'Yatak Formuna Dönüştürülebilir',
        'Silinebilir Örme Kumaş',
        'Robot Süpürge Uyumlu',
        'Seyyar Sırt Minderleri',
        'Üçlü-İkili-Berjer Modülleri',
        'Farklı Renk Alternatifleri'
      ],
      dimensions: 'G: 240cm, D: 100cm, Y: 72cm',
      material: 'Fırınlanmış Gürgen İskelet',
      warranty: 'Weltew Fabrika Garantisi',
      price: "58.836,00 ₺'den başlayan fiyatlarla",
    },
    'cunda-koltuk-takimi': {
      name: 'Cunda Koltuk Takımı',
      image: '../files/cunda-koltuk-takimi.jpg',
      description: 'Gürgen ve kayın ağacı iskelet, antibakteriyel temizlenebilir kumaşlar ve sırt mekanizması ile maksimum konfor sunar.',
      features: [
        '3+3+1 Modüler Sistem',
        'Gürgen & Kayın Ağacı İskelet',
        'Antibakteriyel Kumaş',
        'Sırt Mekanizmalı',
        'Temizlenebilir Döşeme',
        'Özel Tasarım Ayaklar',
        'Renk Seçenekleri',
        'Kanserojen Madde İçermez'
      ],
      dimensions: 'G: 235cm, D: 100cm, Y: 84cm',
      material: 'Gürgen & Kayın Ağacı',
      warranty: '2 Yıl Garanti',
      price: "47.742,00 ₺'den başlayan fiyatlarla",
    },
    'bodrum-koltuk-takimi': {
      name: 'Bodrum Koltuk Takımı',
      image: '../files/weltew-mobilya.webp',
      description: 'Özel dokuma kumaşı ile ferah ve modern görünüm, açılabilir sırt mekanizması ile çok yönlü kullanım sunuyor.',
      features: [
        'Yeni Nesil Bohem Tasarım',
        'Özel Dokuma Kumaş',
        'Açılabilir Sırt Mekanizması',
        'Üçlü-İkili-Berjer Modülleri',
        'Silinebilir Kumaş',
        'Yatak & TV Oturum Özelliği',
        'Robot Süpürge Dostu',
        'Doğal Kurutulmuş Ahşap'
      ],
      dimensions: 'Üçlü-İkili-Berjer Modüler Sistem',
      material: 'Kurutulmuş Gürgen + Kontra & Sunta Levha + Dokuma Kumaş',
      warranty: 'Weltew Fabrika Garantisi',
      price: "51.332,00 ₺'den başlayan fiyatlarla",
    },
    'bodrum-genc-odasi': {
      name: 'Bodrum Genç Odası',
      image: '../files/bodrum-genc-odasi.jpg',
      description: 'E1 standartlarına sahip malzemeler ve çocuk güvenliği sertifikalı boyalar ile üretilmiş genç odası takımı. Gardrop, çalışma masası, şifonyer ve kitaplık modülleri ile tam donanımlı.',
      features: [
        'E1 Standartlı Melamin Kaplama',
        'EN 71-3 Çocuk Güvenli Boya',
        'Frenli Ray & Menteşe Sistemi',
        'Deprem Bağlantı Elemanı',
        'Polyester Döküm Kulplar',
      ],
      dimensions: 'Modüler Sistem - Çeşitli Kombinasyonlar',
      material: 'E1 Melamin Kaplı Yonga Levha',
      warranty: '2 Yıl Garanti',
      price: "55.056,00 ₺'den başlayan fiyatlarla",
    },
    'lotus-genc-odasi': {
      name: 'Lotus Genç Odası',
      image: '../files/lotus-genc-odasi.jpg',
      description: 'Rustik tarzıyla öne çıkan ve beyaz rengini tozpembe tonlarla tamamlayan Lotus genç odası, doğal görünümüne özgün bir kimlik kazandıran Lotus çiçeği süsleriyle farklılaşıyor.',
      features: [
        'E1 Standartlı Melamin Kaplama',
        'Lotus Çiçeği Detayları',
        'Rustik & Modern Tarz',
        'Frenli Menteşe Sistemi',
        'Deprem Bağlantı Elemanı'
      ],
      dimensions: 'Modüler Sistem - Çeşitli Kombinasyonlar',
      material: 'E1 Melamin Kaplı Yonga Levha',
      warranty: '2 Yıl Garanti',
      price: "56.771,00 ₺'den başlayan fiyatlarla",
    },
    'phoenix-white-genc-odasi': {
      name: 'Phoenix White Genç Odası',
      image: '../files/phoenix-white-genc-odasi.webp',
      description: 'Phoenix White Genç Odası, hayatın ve oyunların en heyecan verici unsurlarını birleştiriyor. Phoenix efsanesinden esinlenerek, bir oyuncunun her respawn’unda olduğu gibi, sürekli yenilenme ve öğrenme imkanını vurgular. Gençler bu odada, beyaz renginin ilham veren tonlarıyla harekete geçer, kendi dünyalarını, hayallerini ve hedeflerini şekillendirirler.',
      features: [
        'Phoenix efsanesinden ilham alan tasarım',
        'Beyazın ilham veren tonları',
        'Sürekli yenilenme ve öğrenme imkanı',
        'Hayal ve hedefleri şekillendiren alan',
        'Sade ve fonksiyonel yaşam alanı',
      ],
      dimensions: 'Modüler Sistem - Çeşitli Kombinasyonlar',
      material: 'Demir Profil + Kumaş',
      warranty: '2 Yıl Garanti',
      price: "70.319,00 ₺'den başlayan fiyatlarla",
    }
  };
  return (
    <div className="weltew-mobilya">
      <Header />
      
      <main className="main-content">
        {/* Hero Section */}
        <section className="page-hero">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <div className="brand-logo">
              <img src="../files/weltew-logo.png" alt="Weltew Mobilya Logo" />
            </div>
            <h1>Weltew Mobilya Koleksiyonu</h1>
            <p>Premium kalitede mobilya çözümleri ile evinizi güzelleştirin</p>
          </div>
        </section>

        {/* Products Section */}
        <section className="products-section">
          <div className="container">
            <h2>Öne Çıkan Ürünlerimiz</h2>
            
            {/* Yatak Odası */}
            <div className="category-section" id="yatak-odasi">
              <h3 className="category-title">🛏️ Yatak Odası</h3>
              <div className="products-grid">
                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/traverta-yatak-odasi.webp" alt="Weltew Yatak Odası 1" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('traverta-yatak-odasi')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Traverta Yatak Odası</h4>
                    <p>Doğanın benzersiz desenlerinden ilham alan özel koleksiyon</p>
                    <div className="product-features">
                      <span className="feature">✓ Traverten Dokusu</span>
                      <span className="feature">✓ LED Aydınlatma</span>
                      <span className="feature">✓ E1 Uygunluk Belgeli</span>
                    </div>
                    <div className="product-price">
                      <span className="price">117.227,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/bodrum-yatak-odasi.webp" alt="Weltew Yatak Odası 2" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('bodrum-yatak-odasi')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Bodrum Yatak Odası</h4>
                    <p>Doğal ahşap dokusunu cam ve kumaşla buluşturan eşsiz tasarım</p>
                    <div className="product-features">
                      <span className="feature">✓ Bronz Reflekte Cam</span>
                      <span className="feature">✓ Doğal Ahşap Detaylar</span>
                      <span className="feature">✓ Uzun Ömürlü Yapı</span>
                    </div>
                    <div className="product-price">
                      <span className="price">126.661,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/salda-yatak-odasi.webp" alt="Weltew Yatak Odası 3" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('salda-yatak-odasi')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Salda Yatak Odası</h4>
                    <p>Çağdaş tasarım ve kaliteyle maksimum konfor</p>
                    <div className="product-features">
                      <span className="feature">✓ LED Aydınlatma</span>
                      <span className="feature">✓ Gizli Depolama</span>
                      <span className="feature">✓ Minimalist Stil</span>
                    </div>
                    <div className="product-price">
                      <span className="price">110.507,00 ₺</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Yemek Odası */}
            <div className="category-section" id="yemek-odasi">
              <h3 className="category-title">🍽️ Yemek Odası</h3>
              <div className="products-grid">
                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/traverta-yemek-odasi.webp" alt="Traverta Yemek Odası" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('traverta-yemek-odasi')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Traverta Yemek Odası</h4>
                    <p>Doğanın benzersiz desenlerinden ilham alan özel koleksiyon</p>
                    <div className="product-features">
                      <span className="feature">✓ Traverten Dokusu</span>
                      <span className="feature">✓ Oval Hatlar</span>
                      <span className="feature">✓ Ergonomik Tasarım</span>
                    </div>
                    <div className="product-price">
                      <span className="price">68.225,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/bodrum-yemek-odasi.webp" alt="Bodrum Yemek Odası" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('bodrum-yemek-odasi')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Bodrum Yemek Odası</h4>
                    <p>Bohem zarafeti ve modern şıklığın mükemmel uyumu</p>
                    <div className="product-features">
                      <span className="feature">✓ Özgün Sandalye</span>
                      <span className="feature">✓ Modern Aydınlatma</span>
                      <span className="feature">✓ Ahşap Şıklığı</span>
                    </div>
                    <div className="product-price">
                      <span className="price">65.719,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/cunda-yemek-odasi.jpg" alt="Cunda Yemek Odası" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('cunda-yemek-odasi')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Cunda Yemek Odası</h4>
                    <p>Doğal ahşap dokusunu modern tasarımla buluşturan</p>
                    <div className="product-features">
                      <span className="feature">✓ Doğal Ahşap</span>
                      <span className="feature">✓ El İşçiliği</span>
                      <span className="feature">✓ Özel Tasarım</span>
                    </div>
                    <div className="product-price">
                      <span className="price">63.777,00 ₺</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Koltuk Takımı */}
            <div className="category-section" id="koltuk-takimi">
              <h3 className="category-title">🛋️ Koltuk Takımı</h3>
              <div className="products-grid">
                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/traverta-koltuk-takimi.jpg" alt="Traverta Koltuk Takımı" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('traverta-koltuk-takimi')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Traverta Koltuk Takımı</h4>
                    <p>Yıla damga vuran özel taş dokularından ilham alan koleksiyon</p>
                    <div className="product-features">
                      <span className="feature">✓ Kuş Tüyü Rahatlığı</span>
                      <span className="feature">✓ Yatak Formu</span>
                      <span className="feature">✓ Silinebilir Kumaş</span>
                    </div>
                    <div className="product-price">
                      <span className="price">58.836,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/cunda-koltuk-takimi.jpg" alt="Cunda Koltuk Takımı" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('cunda-koltuk-takimi')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Cunda Koltuk Takımı</h4>
                    <p>3+3+1 modüler sistem ile antibakteriyel konfor</p>
                    <div className="product-features">
                      <span className="feature">✓ Sırt Mekanizmalı</span>
                      <span className="feature">✓ Antibakteriyel</span>
                      <span className="feature">✓ Temizlenebilir</span>
                    </div>
                    <div className="product-price">
                      <span className="price">47.742,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/weltew-mobilya.webp" alt="Bodrum Koltuk Takımı" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('bodrum-koltuk-takimi')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Bodrum Koltuk Takımı</h4>
                    <p>Yeni nesil bohem anlayışı ile çağdaş tasarım</p>
                    <div className="product-features">
                      <span className="feature">✓ Açılabilir Sırt</span>
                      <span className="feature">✓ Robot Süpürge Dostu</span>
                      <span className="feature">✓ Ahşap Ayaklar</span>
                    </div>
                    <div className="product-price">
                      <span className="price">51.332,00 ₺</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Genç Odası */}
            <div className="category-section" id="genc-odasi">
              <h3 className="category-title">👦🏻 Genç Odası</h3>
              <div className="products-grid">
                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/bodrum-genc-odasi.jpg" alt="Bodrum Genç Odası" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('bodrum-genc-odasi')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Bodrum Genç Odası</h4>
                    <p>E1 standartlarında güvenli malzemeler ile üretilmiş</p>
                    <div className="product-features">
                      <span className="feature">✓ E1 Standartları</span>
                      <span className="feature">✓ CE Sertifikalı</span>
                      <span className="feature">✓ Sağlığa ve Çevreye Zararsız Güvenli Boya</span>
                    </div>
                    <div className="product-price">
                      <span className="price">55.056,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/lotus-genc-odasi.jpg" alt="Weltew Genç Odası 2" />
                    <div className="product-overlay">
                      <button 
                        className="view-product"
                        onClick={() => handleProductClick('lotus-genc-odasi')}
                      >
                        Detayları Gör
                      </button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Lotus Genç Odası</h4>
                    <p>Rustik tarzıyla öne çıkan Lotus çiçeği süsleriyle farklılaşan genç odası</p>
                    <div className="product-features">
                      <span className="feature">✓ Rustik & Modern Tarz</span>
                      <span className="feature">✓ Lotus Çiçeği Süsleri</span>
                      <span className="feature">✓ E1 Standartları</span>
                    </div>
                    <div className="product-price">
                      <span className="price">56.771,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/phoenix-white-genc-odasi.webp" alt="Weltew Genç Odası 3" />
                    <div className="product-overlay">
                      <button 
                        className="view-product"
                        onClick={() => handleProductClick('phoenix-white-genc-odasi')}
                      >
                        Detayları Gör
                      </button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Phoenix White Genç Odası</h4>
                    <p>Beyazın enerjisiyle gençlere sürekli yenilenme ve öğrenme fırsatı sunan oda</p>
                    <div className="product-features">
                      <span className="feature">✓ Beyazın enerjisi</span>
                      <span className="feature">✓ Hayal ve hedef alanı</span>
                      <span className="feature">✓ Sade ve fonksiyonel</span>
                    </div>
                    <div className="product-price">
                      <span className="price">70.319,00 ₺</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="features-section">
          <div className="container">
            <h2>Weltew Mobilya Avantajları</h2>
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">🏆</div>
                <h3>Premium Kalite</h3>
                <p>En kaliteli malzemeler ve üstün işçilik</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🎨</div>
                <h3>Modern Tasarım</h3>
                <p>Çağdaş ve şık tasarım anlayışı</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🛡️</div>
                <h3>Uzun Ömürlü</h3>
                <p>Dayanıklı yapı ile yıllar boyu kullanım</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🚚</div>
                <h3>Ücretsiz Teslimat</h3>
                <p>Adresinize kadar ücretsiz teslimat</p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="contact-section">
          <div className="container">
            <div className="contact-content">
              <h2>Daha Fazlası İçin Bizimle İletişime Geçin</h2>
              <p>Weltew Mobilya ürünleri hakkında detaylı bilgi almak ve fiyat teklifi için bize ulaşın.</p>
              <div className="contact-buttons">
                <a href="tel:+905496250335" className="btn btn-primary">📞 Hemen Ara</a>
                <a href="https://wa.me/905496250335" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                  <FaWhatsapp style={{ marginRight: 8, fontSize: 20, verticalAlign: 'middle' }} />
                  WhatsApp
                </a>
                <Link to="/kurumsal" className="btn btn-outline">🏪 Mağazamızı Ziyaret Edin</Link>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Product Detail Modal */}
      {isDetailOpen && selectedProduct && products[selectedProduct] && (
        <div className="product-detail-modal">
          <div className="modal-overlay" onClick={closeDetail}></div>
          <div className="modal-content">
            <button className="close-button" onClick={closeDetail}>
              <FaTimes />
            </button>
            
            <div className="modal-body">
              <div className="product-image-section">
                <img 
                  src={products[selectedProduct]?.image || '../files/traverta-yatak-odasi.webp'} 
                  alt={products[selectedProduct]?.name || 'Ürün'}
                  className="detail-image"
                />
              </div>
              
              <div className="product-info-section">
                <h2>{products[selectedProduct]?.name || 'Ürün Adı'}</h2>
                <p className="product-description">{products[selectedProduct]?.description || 'Açıklama bulunamadı'}</p>
                
                <div className="product-details">
                  <h3>Özellikler</h3>
                  <ul className="features-list">
                    {(products[selectedProduct]?.features || []).map((feature, index) => (
                      <li key={index}>✓ {feature}</li>
                    ))}
                  </ul>
                  
                  <div className="specifications">
                    <h3>Teknik Özellikler</h3>
                    <div className="spec-item">
                      <strong>Boyutlar:</strong> {products[selectedProduct]?.dimensions || 'Belirtilmemiş'}
                    </div>
                    <div className="spec-item">
                      <strong>Malzeme:</strong> {products[selectedProduct]?.material || 'Belirtilmemiş'}
                    </div>
                    <div className="spec-item">
                      <strong>Garanti:</strong> {products[selectedProduct]?.warranty || 'Belirtilmemiş'}
                    </div>
                    <div className="spec-item price">
                      <strong>Fiyat:</strong> {products[selectedProduct]?.price || 'Fiyat için iletişime geçin'}
                    </div>
                  </div>
                  
                  <div className="action-buttons">
                    <a href="tel:+905496250335" className="btn btn-primary">
                      📞 Fiyat Bilgisi Al
                    </a>
                    <a href="https://wa.me/905496250335" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                      <FaWhatsapp style={{ marginRight: 8 }} size={25}/>
                      WhatsApp
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default WeltewMobilya;
